import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import firebase from "firebase/compat/app";
import { DataGrid, GridToolbar, GridActionsCellItem } from "@mui/x-data-grid";
import { Delete, Clear, ArrowForward, ExpandMore, ExpandLess } from "@mui/icons-material";
import EditIcon from '@mui/icons-material/Edit';
import InfoIcon from "@mui/icons-material/Info";
import MuiAlert from "@mui/material/Alert";
import { formattedDate } from "../utils/dateHelpers";
import { serverTimestamp } from 'firebase/firestore';
import dayjs from 'dayjs';

import {
  Button,
  Modal,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Fab,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TablePagination,
  Snackbar,
  IconButton,
  InputAdornment,
  Grid,
  Typography,
  Divider
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from '@mui/icons-material/Clear';
import useCustomParams from "./shared/useCustomParams";
import InfiniteScrollSelect from "components/shared/InfiniteScrollSelect";
import ProjectStatus from "pages/ProjectStatus";
import { display } from "@mui/system";

import DetailTemplateComponent from './DetailTemplateComponent';

import { GridComponent, ColumnsDirective, ColumnDirective, Page, Inject, Sort, Filter, DetailRow, ExcelExport, Toolbar, ColumnChooser } from '@syncfusion/ej2-react-grids';

import "../styles/WorkTypes.css"




const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const WorkTypes = ({ userId, projectId, contacts, isInactive, projectDOB }) => {



  const [workTypes, setWorkTypes] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [newWorkType, setNewWorkType] = useState("");
  const [estimatedCost, setEstimatedCost] = useState("");
  const [applicant, setApplicant] = useState("");
  const [filingRepresentative, setFilingRepresentative] = useState("");
  const [dateCreated, setDateCreated] = useState("");
  const [dobNumber, setDobNumber] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [dateApproved, setDateApproved] = useState("");
  const [permitIssued, setPermitIssued] = useState("");
  const [permitExpiration, setPermitExpiration] = useState("");
  const [signOffRequested, setSignOffRequested] = useState("");
  const [signedOffOn, setSignedOffOn] = useState("");
  const [locDate, setLocDate] = useState("");

  const [comments, setComments] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [currentWorkType, setCurrentWorkType] = useState(null);
  const [openUpdateModal, setOpenUpdateModal] = useState(false)
  // const [rows,setRows]=useState([])
  const [originalWorkType, setOriginalWorkType] = useState(null);


  const isDirty = React.useMemo(() => {
    if (!originalWorkType || !currentWorkType) return false;
    const keys = [
      'workType', 'estimatedCost', 'applicant', 'filingRepresentative',
      'dateFiled', 'dateApproved', 'permitIssued', 'permitExpiration',
      'signOffRequested', 'signedOffOn', 'locDate', 'dobNumber', 'comments'
    ];
    return keys.some(key => {
      const orig = originalWorkType[key];
      const curr = currentWorkType[key];
      return String(orig) !== String(curr);
    });
  }, [originalWorkType, currentWorkType]);



  const [openWorkTypeInfoModal, setOpenWorkTypeInfoModal] = useState(false)

  const [displayWorktypeInfo, setDisplayWorktypeInfo] = useState({
    display: false,
    dobNumber: ''
  })

  const [currentWorkInfoData, setCurrentWorkInfoData] = useState([])




  const [displayProjectStatus, setDisplayProjectStatus] = useState({
    display: false,
    dobNumber: ''
  })




  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    severity: 'success'
  });



  //Table ToolBar
  const gridRef = useRef(null);

  const toolbarOptions = ['ExcelExport', 'CsvExport', 'ColumnChooser'];
  // const toolbarClick = (args) => {
  //   if (gridRef && gridRef.current) {
  //     if (args.item.id.includes('excelexport')) {
  //       gridRef.current.excelExport();
  //     }
  //     if (args.item.id.includes('csvexport')) {
  //       gridRef.current.csvExport();
  //     }
  //   }
  // };

  const toolbarClick = (args) => {
    if (gridRef.current) {
      if (args.item.id === 'WorkTypesGrid_excelexport') {
        gridRef.current.excelExport();
      }
      if (args.item.id === 'WorkTypesGrid_csvexport') {
        gridRef.current.csvExport();
      }
    }
  };










  useEffect(() => {
    const unsubscribe = firebase
      .firestore()
      .collection("workTypes")
      .where("userId", "==", userId)
      .where("projectId", "==", projectId)
      .onSnapshot((snapshot) => {
        const workTypesData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setWorkTypes(workTypesData);
      });

    return () => {
      unsubscribe();
    };
  }, [userId, projectId]);


  const parseLocalDateToEpoch = s => {
    if (typeof s === "number") {
      return s;
    }
    if (typeof s === "string") {
      const [y, m, d] = s.split("-").map(Number);
      return new Date(y, m - 1, d).getTime();
    }
    return null;
  };


  const formatEpochToInputValue = ms =>
    new Date(ms).toISOString().split("T")[0];



  const handleOpenModal = () => {
    setNewWorkType("");
    setApplicant("");
    setFilingRepresentative("");
    setDateCreated("");
    setDobNumber("");
    setDateCreated(new Date().toISOString().split("T")[0]);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleAddWorkType = async () => {
    try {
      await firebase.firestore().collection("workTypes").add({
        workType: newWorkType,
        estimatedCost,
        applicant,
        filingRepresentative,
        dateFiled: dateCreated,
        dateCreated: Date.now(),
        dateUpdated: currentTimestamp, // Changed to epoch
        dateApproved,
        permitIssued,
        permitExpiration,
        signOffRequested,
        signedOffOn,
        locDate,
        dobNumber,
        comments,
        dobNumber,
        userId,
        projectId,
      });
      setNewWorkType("");
      setEstimatedCost("");
      setApplicant("");
      setFilingRepresentative("");
      setDateCreated("");
      setDateApproved("");
      setPermitIssued("");
      setPermitExpiration("");
      setSignOffRequested("");
      setSignedOffOn("");
      setLocDate("");
      setDateCreated("");
      setDobNumber("");
      handleCloseModal();
      openFeedbackMessage('Work type added successfully!', 'success');
    } catch (error) {
      console.error("Error adding work type:", error);
    }
  };
  const currentTimestamp = Date.now();

  const handleUpdateWorkType = async () => {

    try {
      const { id, dateFiled, ...rest } = currentWorkType;
      const formattedDateFiled = dateFiled;  // already the string from your <TextField>


      await firebase
        .firestore()
        .collection("workTypes")
        .doc(id)
        .update({
          ...rest,
          dateFiled: formattedDateFiled,
          dateUpdated: Date.now(),
        });

      handleCloseUpdateModal();
      openFeedbackMessage('Work type updated successfully!', 'success');
    } catch (error) {
      console.error("Error updating work type:", error);
    }
  };


  const onQueryCellInfo = (args) => {
    if (!args.column) return;

    if (args.column.field === "dobNumber") {
      args.cell.style.fontWeight = "700";
    }
  };


  const handleCloseUpdateModal = () => {
    setOpenUpdateModal(false)
  }


  const editDocument = (id) => {
    const workTypeToEdit = workTypes.find(w => w.id === id);
    if (workTypeToEdit) {
      setOriginalWorkType(workTypeToEdit);
      setCurrentWorkType(workTypeToEdit);
      setOpenUpdateModal(true);
    }
  };




  const handleDeleteWorkType = async () => {
    try {
      await firebase.firestore().collection("workTypes").doc(deleteId).delete();
      setOpenConfirmDialog(false);
      setDeleteId(null);
      openFeedbackMessage('Work type deleted successfully!', 'success');
    } catch (error) {
      console.error("Error deleting work type:", error);
    }
  };

  const confirmDeleteWorkType = (id) => {
    setDeleteId(id);
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
    setDeleteId(null);
  };


  const openFeedbackMessage = (message, severity) => {
    setFeedbackMessage({ open: true, message, severity });
  };

  const handleCloseFeedbackMessage = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setFeedbackMessage({ ...feedbackMessage, open: false });
  };



  // const getFilteredData = async (workTypeIDs) => {
  //   if (!workTypeIDs || workTypeIDs.length === 0) {
  //     console.warn("No workTypeIDs provided.");
  //     return [];
  //   }


  //   const workTypeIDsString = workTypeIDs.map(id => `'${id}'`).join(",");


  //   const apiEndpoints = [
  //     { name: "permits", url: `https://data.cityofnewyork.us/resource/ipu4-2q9a.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
  //     { name: "electrical", url: `https://data.cityofnewyork.us/resource/dm9a-ab7w.json?$where=job_number in(${workTypeIDsString})&$limit=50000` },
  //     { name: "dobJobs", url: `https://data.cityofnewyork.us/resource/rvhx-8trz.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
  //     { name: "applicationFilings", url: `https://data.cityofnewyork.us/resource/ic3t-wcy2.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
  //     { name: "permitIssuance", url: `https://data.cityofnewyork.us/resource/ipu4-2q9a.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
  //   ];

  //   const dynamicEndpoints = [
  //     {
  //       name: "dobNowJobs",
  //       baseUrl: "https://data.cityofnewyork.us/resource/w9ak-ipjd.json?$where=starts_with(job_filing_number, '{id}')&$limit=50000",
  //     },
  //     {
  //       name: "approvedPermits",
  //       baseUrl: "https://data.cityofnewyork.us/resource/rbx6-tga4.json?$where=starts_with(job_filing_number, '{id}')&$limit=50000",
  //     }
  //   ];

  //   try {

  //     const staticApiCalls = apiEndpoints.map(endpoint =>
  //       axios.get(endpoint.url)
  //         .then(response => response.data)
  //         .catch(error => {
  //           console.error(`Error fetching ${endpoint.name}:`, error);
  //           return [];
  //         })
  //     );


  //     const dynamicApiCalls = dynamicEndpoints.flatMap(endpoint =>
  //       workTypeIDs.map(id =>
  //         axios.get(endpoint.baseUrl.replace("{id}", id))
  //           .then(response => response.data)
  //           .catch(error => {
  //             console.error(`Error fetching ${endpoint.name} for ${id}:`, error);
  //             return [];
  //           })
  //       )
  //     );


  //     const results = await Promise.all([...staticApiCalls, ...dynamicApiCalls]);


  //     const extractFields = (data) =>
  //       data.map(item => ({
  //         approvalDate: item.approved_date || null,
  //         permitNumber: item.work_permit || null,
  //         permitIssued: item.issued_date || null,
  //         permitExpires: item.expired_date || null,
  //         signOffDate: item.sign_off_date || item.signoff_date || null,
  //         locDate: item.c_o_issue_date || null,
  //       }));

  //     const allData = results.flatMap(extractFields);
  //     return allData;
  //   } catch (error) {
  //     console.error("Error fetching work types data:", error);
  //     return [];
  //   }
  // };








  const columns = [
    {
      field: "workType",
      headerName: "Work Type",
      headerAlign: "Center",
      textAlign: "Center",

    },

    {
      field: "estimatedCost",
      headerName: "Estimated Cost",
      type: "number",
      format: 'C0',
      headerAlign: "Center",
      textAlign: "Center",

    },

    {
      field: "applicantName", headerName: "Applicant", headerAlign: "Center",
      textAlign: "Center",
    },
    {
      field: "filingRepresentativeName",
      headerName: "Filing Rep",
      headerAlign: "Center",
      textAlign: "Center",

    },

    {
      field: "dateFiled",
      headerName: "Date Filed",
      headerAlign: "Center",
      textAlign: "Center",
    },
    {
      field: "dateApproved",
      headerName: "Approved",
      headerAlign: "Center",
      textAlign: "Center",
    },
    {
      field: "permitIssued",
      headerName: "Issued",
      headerAlign: "Center",
      textAlign: "Center",
      visible: false

    },
    {
      field: "permitExpiration",
      headerName: "Expiration",
      headerAlign: "Center",
      textAlign: "Center",
    },
    {
      field: "signOffRequested",
      headerName: "Sign-off Requested",
      headerAlign: "Center",
      textAlign: "Center",
    },
    {
      field: "signedOffOn",
      headerName: "Signed Off On",
      headerAlign: "Center",
      textAlign: "Center",
    },
    {
      field: "locDate",
      headerName: "LOC",
      headerAlign: "Center",
      textAlign: "Center",
    },
    {
      field: "dobNumber",
      headerName: "DOB Number",
      headerTextAlign: "Center",
      textAlign: "Center",
      headerAttributes: { class: 'dob-header' }
    },

    {
      field: "comments",
      headerName: "Comments",
      headerAlign: "Center",
      textAlign: "Center",

    },
  ];



  // const columns = [
  //   { field: "workType", headerName: "Work Type", width: 150 },
  //   { field: "estimatedCost", headerName: "Estimated Cost", width: 150 },
  //   { field: "applicantName", headerName: "Applicant", width: 150 },
  //   {
  //     field: "filingRep",
  //     headerName: "Filing Representative",
  //     width: 200,
  //   },
  //   { field: "dateCreated", headerName: "Date Filed", width: 150 },
  //   { field: "dobNumber", headerName: "DOB Number", width: 150 },
  //   { field: "approvalDate", headerName: "Approval Date",  },
  //   { field: "permitNumber", headerName: "Permit Number",  },
  //   { field: "permitIssued", headerName: "Permit Issued",  },
  //   { field: "permitExpires", headerName: "Permit Expires",  },
  //   { field: "signOffDate", headerName: "Sign Off Date", },
  //   { field: "locDate", headerName: "Location Issue Date",  },
  // ];







  //importantttttttttttttttttttttt
  // if (!isInactive) {
  //   columns.push({
  //     field: "actions",
  //     headerName: "Actions",
  //     width: 150,
  //     renderCell: (params) => (
  //       <>
  //         <GridActionsCellItem
  //           icon={<EditIcon />}
  //           onClick={() => editDocument(params.row.id)}
  //           label="Edit"
  //         />
  //         <GridActionsCellItem
  //           icon={<Delete />}
  //           onClick={(event) => {
  //             event.stopPropagation(); // Prevent row click event
  //             confirmDeleteWorkType(params.row.id);
  //           }}
  //           label="Delete"
  //         />
  //         {(params.row.dobNumber!=='' && params.row.dobNumber!==undefined && !isInactive) && 
  //     <GridActionsCellItem
  //     icon={<ArrowForward />}
  //      onClick={(event) => {
  //     event.stopPropagation(); // Prevent row click event
  //     openProjectStatus(params.row);
  //     }}
  //      label="Delete"
  //      />
  //         }
  //        {/* {(params.row.dobNumber!=='' && params.row.dobNumber!==undefined && !isInactive) && 
  //     <GridActionsCellItem
  //     icon={<InfoIcon />}
  //      onClick={(event) => {
  //     event.stopPropagation(); // Prevent row click event
  //     openWorktypeInfo(params.row);
  //     }}
  //      label="Delete"
  //      />
  //         } */}

  //       </>
  //     ),
  //   });
  // }

  const formatFirestoreDate = (ts) => {
    if (!ts) return "";
    if (typeof ts.seconds === "number") {
      const d = new Date(ts.seconds * 1000);
      return d.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
    }
    const d = new Date(ts);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };




  const rows = workTypes.map((workType, index) => ({
    id: workType.id,

    workType: workType.workType,
    estimatedCost: workType.estimatedCost ? Number(workType.estimatedCost) : null, applicantName:
      contacts.find((contact) => contact.id === workType.applicant)?.fullName ||
      "",
    filingRepresentativeName:
      contacts.find((contact) => contact.id === workType.filingRepresentative)
        ?.fullName || "",
    dateFiled: workType.dateFiled
      ? workType.dateFiled   // assuming it’s already “YYYY-MM-DD”
      : "",
    dateApproved: workType.dateApproved ? dayjs(workType.dateApproved).format('YYYY-MM-DD') : "",
    permitIssued: workType.permitIssued ? dayjs(workType.permitIssued).format('YYYY-MM-DD') : "",
    permitExpiration: workType.permitExpiration ? dayjs(workType.permitExpiration).format('YYYY-MM-DD') : "",
    signOffRequested: workType.signOffRequested ? dayjs(workType.signOffRequested).format('YYYY-MM-DD') : "",
    signedOffOn: workType.signedOffOn ? dayjs(workType.signedOffOn).format('YYYY-MM-DD') : "",
    locDate: workType.locDate ? dayjs(workType.locDate).format('YYYY-MM-DD') : "",

    dobNumber: workType.dobNumber || "",
    comments: workType.comments || "",
  }));



  // const rows = workTypes.flatMap((workType, index) => [
  //   {
  //     id: workType.id, 
  //     workType: workType.workType,
  //     estimatedCost: workType.estimatedCost,
  //     applicantName:
  //       contacts.find((contact) => contact.id === workType.applicant)?.fullName ||
  //       "",
  //     filingRepresentativeName:
  //       contacts.find((contact) => contact.id === workType.filingRepresentative)
  //         ?.fullName || "",
  //     dateCreated: workType.dateCreated,
  //     dobNumber: workType.dobNumber,
  //   },
  //   {
  //     id: `${workType.id}-empty`, 
  //     workType: "",
  //     estimatedCost: "",
  //     applicantName: "",
  //     filingRepresentativeName: "",
  //     dateCreated: "",
  //     dobNumber: "",
  //   },
  // ]);





  // const fetchDataAndGenerateRows = async (workType) => {
  //   try {

  //     const allData=await getFilteredData([workType.dobNumber||"hghjgfjgjfgj"]);



  //       // const allData = [
  //       //   {
  //       //     approvalDate: "2025-01-01",
  //       //     permitNumber: "ABC123456",
  //       //     permitIssued: "2025-01-05",
  //       //     permitExpires: "2025-12-31",
  //       //     signOffDate: "2025-06-01",
  //       //     locDate: "2025-01-10",
  //       //   },
  //       //   {
  //       //     approvalDate: "2025-02-01",
  //       //     permitNumber: "XYZ987654",
  //       //     permitIssued: "2025-02-05",
  //       //     permitExpires: "2025-12-31",
  //       //     signOffDate: "2025-07-01",
  //       //     locDate: "2025-02-10",
  //       //   },
  //       // ];

  //     const originalRow = {
  //       id: workType.id,
  //       workType: workType.workType,
  //       estimatedCost: workType.estimatedCost,
  //       applicantName:
  //         contacts.find((contact) => contact.id === workType.applicant)?.fullName ||
  //         "",
  //       filingRepresentativeName:
  //         contacts.find((contact) => contact.id === workType.filingRepresentative)
  //           ?.fullName || "",
  //       dateCreated: workType.dateCreated,
  //       dobNumber: workType.dobNumber,
  //     };
  //     let rows = [originalRow];
  //     // rows.push(originalRow);

  //     allData.forEach((item) => {
  //       const additionalRow = {
  //         id: `${workType.id}-additional-${item.permitNumber || item.approvalDate}`, 
  //         workType: "",
  //         estimatedCost: "",
  //         applicantName:"",
  //         filingRepresentativeName: "",
  //         dateCreated: "",
  //         dobNumber:"",
  //         approvalDate: item.approvalDate || null,
  //         permitNumber: item.permitNumber || null,
  //         permitIssued: item.permitIssued || null,
  //         permitExpires: item.permitExpires || null,
  //         signOffDate: item.signOffDate || null,
  //         locDate: item.locDate || null,
  //       };
  //       rows = [...rows, additionalRow];
  //       // rows.push(additionalRow);
  //     });

  //     return rows;

  //   } catch (error) {
  //     console.error(`Error fetching data for workType ${workType.id}:`, error);
  //   }
  // };


  // const processWorkTypes = async () => {
  //   let allRows = []; 
  //   for (const workType of workTypes) {
  //     // await fetchDataAndGenerateRows(workType);
  //     const rows = await fetchDataAndGenerateRows(workType); 
  //      allRows = [...allRows, ...rows]; 
  //   }
  //   return allRows

  // };



  // const getRows = async () => {
  //   const rows = await processWorkTypes();
  //   setRows(rows)
  //   console.log("Rows:", rows);
  // };

  // useEffect(async()=>{
  //   await getRows()
  // },[workTypes])












  // const [paginationModel, setPaginationModel] = useState({
  //   pageSize: 50,
  //   page: 0,
  // });

  const { params, updateParams } = useCustomParams();

  const pageSize =
    Number(params.get("pageSize")) || 50,
    page = Number(params.get("page")) || 0;




  const openProjectStatus = (params) => {
    setDisplayProjectStatus({
      display: true,
      dobNumber: params.dobNumber
    })
  }



  // const openWorktypeInfo=(params)=>{
  //   setDisplayWorktypeInfo({
  //     display:true,
  //     dobNumber:params.dobNumber
  //   })
  //   }



  const handleCloseFromWorkTypeDobTable = () => {
    setDisplayProjectStatus((prev) => {
      return {
        ...prev,
        display: false
      }
    })
  }


  if (displayProjectStatus.display) {
    return (<div style={{ height: "calc(100vh - 230px)" }}>
      <ProjectStatus
        //  thisProject={projectDOB}
        workTypeIDs={[displayProjectStatus.dobNumber]}
        fromWorkType={true}
        handleCloseFromWorkType={handleCloseFromWorkTypeDobTable}
      />
    </div>)
  }



  // if(displayWorktypeInfo.display){

  // const getFilteredData = async (workTypeIDs) => {
  //   if (!workTypeIDs || workTypeIDs.length === 0) {
  //     console.warn("No workTypeIDs provided.");
  //     return [];
  //   }

  //   const workTypeIDsString = workTypeIDs.map(id => `'${id}'`).join(",");
  //   // API endpoints mapped to respective workType fields
  //   const apiEndpoints = [
  //     { name: "permits", url: `https://data.cityofnewyork.us/resource/ipu4-2q9a.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
  //     { name: "electrical", url: `https://data.cityofnewyork.us/resource/dm9a-ab7w.json?$where=job_number in(${workTypeIDsString})&$limit=50000` },
  //     { name: "dobJobs", url: `https://data.cityofnewyork.us/resource/rvhx-8trz.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
  //     { name: "applicationFilings", url: `https://data.cityofnewyork.us/resource/ic3t-wcy2.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
  //     { name: "permitIssuance", url: `https://data.cityofnewyork.us/resource/ipu4-2q9a.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
  //   ];

  //   // Dynamic endpoints that iterate over workTypeIDs individually
  //   const dynamicEndpoints = [
  //     {
  //       name: "dobNowJobs",
  //       baseUrl: "https://data.cityofnewyork.us/resource/w9ak-ipjd.json?$where=starts_with(job_filing_number, '{id}')&$limit=50000",
  //     },
  //     {
  //       name: "approvedPermits",
  //       baseUrl: "https://data.cityofnewyork.us/resource/rbx6-tga4.json?$where=starts_with(job_filing_number, '{id}')&$limit=50000",
  //     }
  //   ];

  //   try {

  //     const staticApiCalls = apiEndpoints.map(endpoint =>
  //       axios.get(endpoint.url)
  //         .then(response => response.data)
  //         .catch(error => {
  //           console.error(`Error fetching ${endpoint.name}:`, error);
  //           return [];
  //         })
  //     );


  //     const dynamicApiCalls = dynamicEndpoints.flatMap(endpoint =>
  //       workTypeIDs.map(id =>
  //         axios.get(endpoint.baseUrl.replace("{id}", id))
  //           .then(response => response.data)
  //           .catch(error => {
  //             console.error(`Error fetching ${endpoint.name} for ${id}:`, error);
  //             return [];
  //           })
  //       )
  //     );


  //     const results = await Promise.all([...staticApiCalls, ...dynamicApiCalls]);


  //     const extractFields = (data) =>
  //       data.map(item => ({
  //         approvalDate: item.approved_date || null,
  //         permitNumber: item.work_permit || null,
  //         permitIssued: item.issued_date || null,
  //         permitExpires: item.expired_date || null,
  //         signOffDate: item.sign_off_date || item.signoff_date || null,
  //         locDate: item.c_o_issue_date || null,
  //       }));

  //     const allData = results.flatMap(extractFields);

  //     console.log("Filtered Work Types Data:", allData);
  //     setCurrentWorkInfoData(allData)

  //     return allData;
  //   } catch (error) {
  //     console.error("Error fetching work types data:", error);
  //     return [];
  //   }
  // };
  // getFilteredData([displayWorktypeInfo.dobNumber])
  //  setOpenWorkTypeInfoModal(true)
  // setDisplayWorktypeInfo((prev)=>({
  //   ...prev,
  //   display:false
  // }))


  // }




  // const handleCloseWorkTypeInfoModal = () => {
  //   setOpenWorkTypeInfoModal(false)
  // }



  // const getFilteredData = async (workTypeIDs) => {
  //   if (!workTypeIDs || workTypeIDs.length === 0) {
  //     console.warn("No workTypeIDs provided.");
  //     return [];
  //   }

  //   const workTypeIDsString = workTypeIDs.map(id => `'${id}'`).join(",");

  //   const apiEndpoints = [
  //     { name: "permits", url: `https://data.cityofnewyork.us/resource/ipu4-2q9a.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
  //     { name: "electrical", url: `https://data.cityofnewyork.us/resource/dm9a-ab7w.json?$where=job_number in(${workTypeIDsString})&$limit=50000` },
  //     { name: "dobJobs", url: `https://data.cityofnewyork.us/resource/rvhx-8trz.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
  //     { name: "applicationFilings", url: `https://data.cityofnewyork.us/resource/ic3t-wcy2.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
  //     { name: "permitIssuance", url: `https://data.cityofnewyork.us/resource/ipu4-2q9a.json?$where=job__ in(${workTypeIDsString})&$limit=50000` },
  //   ];

  //   const dynamicEndpoints = [
  //     {
  //       name: "dobNowJobs",
  //       baseUrl: "https://data.cityofnewyork.us/resource/w9ak-ipjd.json?$where=starts_with(job_filing_number, '{id}')&$limit=50000",
  //     },
  //     {
  //       name: "approvedPermits",
  //       baseUrl: "https://data.cityofnewyork.us/resource/rbx6-tga4.json?$where=starts_with(job_filing_number, '{id}')&$limit=50000",
  //     }
  //   ];

  //   try {
  //     const staticApiCalls = apiEndpoints.map(endpoint =>
  //       axios.get(endpoint.url)
  //         .then(res => res.data)
  //         .catch(err => {
  //           console.error(`Error fetching ${endpoint.name}`, err);
  //           return [];
  //         })
  //     );

  //     const dynamicApiCalls = dynamicEndpoints.flatMap(endpoint =>
  //       workTypeIDs.map(id =>
  //         axios.get(endpoint.baseUrl.replace('{id}', id))
  //           .then(res => res.data)
  //           .catch(err => {
  //             console.error(`Error fetching ${endpoint.name} for ${id}`, err);
  //             return [];
  //           })
  //       )
  //     );

  //     const results = await Promise.all([...staticApiCalls, ...dynamicApiCalls]);

  //     const extractFields = (data) =>
  //       data.map(item => ({
  //         approvalDate: item.approved_date || null,
  //         permitNumber: item.work_permit || null,
  //         permitIssued: item.issued_date || null,
  //         permitExpires: item.expired_date || null,
  //         signOffDate: item.sign_off_date || item.signoff_date || null,
  //         locDate: item.c_o_issue_date || null,
  //       }));

  //     const allData = results.flatMap(extractFields);
  //     return allData;
  //   } catch (error) {
  //     console.error("Error fetching work types data:", error);
  //     return [];
  //   }
  // };










  const handleRowClick = (args) => {
    console.log("Row clicked:", args);
  };

  // const detailTemplate = (props) => {
  //   return (
  //     <div style={{ padding: '10px', background: '#f8f8f8',height:'400px' }}>
  //       <p>This is your custom expandable content inside the grid.</p>
  //     </div>
  //   );
  // };



  // const detailTemplate = (props) => {
  //   const [workInfo, setWorkInfo] = useState([]);
  //   const [loading, setLoading] = useState(true);

  //   useEffect(() => {
  //     const fetchDetails = async () => {
  //       setLoading(true);
  //       // const jobNumber = props?.dobNumber || props?.job_number || props?.id;
  //       const jobNumber = props?.dobNumber
  //       const result = await getFilteredData([jobNumber]);
  //       setWorkInfo(result);
  //       setLoading(false);
  //     };

  //     fetchDetails();
  //   }, [props]);

  //   return (
  //     <div style={{ padding: '10px', background: '#f8f8f8', minHeight: '200px' }}>
  //       {loading ? (
  //         <p>Loading work type info...</p>
  //       ) : workInfo.length === 0 ? (
  //         <p>No work type info available.</p>
  //       ) : (
  //         <Grid container spacing={2}>
  //           {workInfo.map((item, index) => (
  //             <Grid item xs={12} key={index}>
  //               <Grid container spacing={2}>
  //                 <Grid item xs={12} md={6}>
  //                   <TextField
  //                     label="Approval Date"
  //                     variant="outlined"
  //                     type="date"
  //                     fullWidth
  //                     InputLabelProps={{ shrink: true }}
  //                     value={item.approvalDate ? item.approvalDate.split("T")[0] : ""}
  //                     InputProps={{ readOnly: true }}
  //                   />
  //                 </Grid>
  //                 <Grid item xs={12} md={6}>
  //                   <TextField
  //                     label="Permit Number"
  //                     variant="outlined"
  //                     fullWidth
  //                     value={item.permitNumber || ""}
  //                     InputProps={{ readOnly: true }}
  //                   />
  //                 </Grid>
  //                 <Grid item xs={12} md={6}>
  //                   <TextField
  //                     label="Permit Issued"
  //                     variant="outlined"
  //                     type="date"
  //                     fullWidth
  //                     InputLabelProps={{ shrink: true }}
  //                     value={item.permitIssued ? item.permitIssued.split("T")[0] : ""}
  //                     InputProps={{ readOnly: true }}
  //                   />
  //                 </Grid>
  //                 <Grid item xs={12} md={6}>
  //                   <TextField
  //                     label="Permit Expires"
  //                     variant="outlined"
  //                     type="date"
  //                     fullWidth
  //                     InputLabelProps={{ shrink: true }}
  //                     value={item.permitExpires ? item.permitExpires.split("T")[0] : ""}
  //                     InputProps={{ readOnly: true }}
  //                   />
  //                 </Grid>
  //                 <Grid item xs={12} md={6}>
  //                   <TextField
  //                     label="Sign-Off Date"
  //                     variant="outlined"
  //                     type="date"
  //                     fullWidth
  //                     InputLabelProps={{ shrink: true }}
  //                     value={item.signOffDate ? item.signOffDate.split("T")[0] : ""}
  //                     InputProps={{ readOnly: true }}
  //                   />
  //                 </Grid>
  //                 <Grid item xs={12} md={6}>
  //                   <TextField
  //                     label="LOC Date"
  //                     variant="outlined"
  //                     type="date"
  //                     fullWidth
  //                     InputLabelProps={{ shrink: true }}
  //                     value={item.locDate ? item.locDate.split("T")[0] : ""}
  //                     InputProps={{ readOnly: true }}
  //                   />
  //                 </Grid>
  //               </Grid>
  //               {index < workInfo.length - 1 && (
  //                 <Divider sx={{ my: 2 }} />
  //               )}
  //             </Grid>
  //           ))}
  //         </Grid>
  //       )}
  //     </div>
  //   );
  // };



  const detailTemplate = (props) => {
    return <DetailTemplateComponent data={props} />;
  };




  const onDataBound = () => {
    if (gridRef.current) {
      gridRef.current.autoFitColumns([
        "workType",
        "estimatedCost",
        "applicantName",
        "filingRepresentativeName",
        "dateCreated",
        "dateApproved",
        "permitIssued",
        "permitExpiration",
        "signOffRequested",
        "signedOffOn",
        "locDate",
        "dobNumber",
        "comments",
      ]);
    }
  };


  // const actionTemplate = (props) => (
  //   <div>
  //     <button onClick={() => editDocument(props.id)}>Edit</button>
  //     <button
  //       onClick={(e) => {
  //         e.stopPropagation();
  //         confirmDeleteWorkType(props.id);
  //       }}
  //     >
  //       Delete
  //     </button>
  //     {props.dobNumber && (
  //       <button
  //         onClick={(e) => {
  //           e.stopPropagation();
  //           openProjectStatus(props);
  //         }}
  //       >
  //         Status
  //       </button>
  //     )}
  //   </div>
  // );



  const actionTemplate = (props) => (
    <div>

      <IconButton onClick={() => editDocument(props.id)}>
        <EditIcon />
      </IconButton>


      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          confirmDeleteWorkType(props.id);
        }}
      >
        <Delete />
      </IconButton>

      {props.dobNumber && (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            openProjectStatus(props);
          }}
        >
          <ArrowForward />
        </IconButton>
      )}
    </div>
  );






  return (
    <div style={{ height: 400, width: "100%" }}>

      {/* 

<Modal open={openWorkTypeInfoModal} onClose={handleCloseWorkTypeInfoModal}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 600,
      bgcolor: "white",
      p: 3,
      boxShadow: 24,
      borderRadius: 2,
      maxHeight: "80vh",
      overflowY: "auto",
    }}
  >
    <Typography variant="h6" gutterBottom>
      Work Type Information
    </Typography>

    {currentWorkInfoData.length > 0 ? (
      <Grid container spacing={2}>
        {currentWorkInfoData.map((item, index) => (
          <Grid item xs={12} key={index}>
            <Grid container spacing={2}>
             
              <Grid item xs={12} md={6}>
                <TextField
                  label="Approval Date"
                  variant="outlined"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={item.approvalDate ? item.approvalDate.split("T")[0] : ""}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

             
              <Grid item xs={12} md={6}>
                <TextField
                  label="Permit Number"
                  variant="outlined"
                  fullWidth
                  value={item.permitNumber || ""}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

            
              <Grid item xs={12} md={6}>
                <TextField
                  label="Permit Issued"
                  variant="outlined"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={item.permitIssued ? item.permitIssued.split("T")[0] : ""}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              
              <Grid item xs={12} md={6}>
                <TextField
                  label="Permit Expires"
                  variant="outlined"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={item.permitExpires ? item.permitExpires.split("T")[0] : ""}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

          
              <Grid item xs={12} md={6}>
                <TextField
                  label="Sign-Off Date"
                  variant="outlined"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={item.signOffDate ? item.signOffDate.split("T")[0] : ""}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

           
              <Grid item xs={12} md={6}>
                <TextField
                  label="LOC Date"
                  variant="outlined"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={item.locDate ? item.locDate.split("T")[0] : ""}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            </Grid>

            
             {index < currentWorkInfoData.length - 1 && (
              <Divider sx={{ my: 2 }} />
            )}
          </Grid>
        ))}
      </Grid>
    ) : (
      <Typography>No work type data available.</Typography>
    )}
  </Box>
</Modal> */}


      {/*       
      <DataGrid rows={rows} columns={columns} pageSizeOptions={[10, 25, 50, 100]}
        pagination
        hideFooter
        paginationModel={{ pageSize, page }}
        onRowClick={(params) => editDocument(params.row.id)}
        onPaginationModelChange={(params) => {
          if (workTypes.length > 0)
            updateParams({
              page: params.page,
              pageSize: params.pageSize,
            });
        }}
        rowCount={workTypes.length}
        initialState={{
          pagination: { paginationModel: { pageSize: 50 } },
        }}
        onFilterModelChange={(e) => {
          updateParams({
            pageSize: false,
            page: false,
            search: e?.items?.map((item) => item?.value).join(""),
          });
        }}
        slots={{
          toolbar: GridToolbar,
        }} 
       
        
        /> */}



      {/* <GridComponent
  dataSource={dummyData}
  allowPaging={true}
  pageSettings={{ pageSize: 3 }}
  rowSelected={handleRowClick}
  allowSorting={true}
  allowFiltering={true}
  detailTemplate={detailTemplate}
>
  <ColumnsDirective>
    <ColumnDirective field="id" headerText="ID" textAlign="Right" width="100" />
    <ColumnDirective field="name" headerText="Name" width="200" />
    <ColumnDirective field="age" headerText="Age" textAlign="Right" width="100" />
  </ColumnsDirective>
  <Inject services={[Page, Sort, Filter]} />
</GridComponent> */}

      {/* <GridComponent
       dataSource={dummyData}
      allowPaging={true}
      pageSettings={{ pageSize: 3 }}
      allowSorting={true}
      allowFiltering={true}
      detailTemplate={detailTemplate}  // this is the key
    >
      <ColumnsDirective>
        <ColumnDirective field="id" headerText="ID" textAlign="Right" width="100" />
        <ColumnDirective field="name" headerText="Name" width="200" />
        <ColumnDirective field="age" headerText="Age" textAlign="Right" width="100" />
      </ColumnsDirective>
      <Inject services={[Page, Sort, Filter,DetailRow]} />
    </GridComponent> */}


      <GridComponent
        id="WorkTypesGrid"
        ref={gridRef}
        dataSource={rows}
        allowPaging={true}
        width="100%"
        dataBound={onDataBound}
        pageSettings={{
          pageSize: 10,
          pageSizes: [5, 10, 20, 50],
        }}
        page={(args) => {
          setCurrentPage(args.currentPage);
        }}
        enablePersistence={true}
        persistenceSettings={{ persistPage: true }}
        allowSorting={true}
        allowFiltering={true}
        detailTemplate={detailTemplate}
        allowColumnChooser={true}
        showColumnChooser={true}
        rowSelected={(args) => {
          if (args && args.data && args.data.id) {
            editDocument(args.data.id);
          }
        }} toolbar={toolbarOptions}
        toolbarClick={toolbarClick}
        queryCellInfo={onQueryCellInfo}
        allowExcelExport={true}
        filterSettings={{
          type: 'FilterBar',
          mode: 'Immediate',
          immediateModeDelay: 700,
        }}
      >
        <ColumnsDirective>
          {columns.map((col) => (
            <ColumnDirective
              key={col.field}
              field={col.field}
              headerText={col.headerName}
              type={col.type}
              format={col.format}
              headerTextAlign={col.headerAlign}
              textAlign={col.textAlign}
              headerAttributes={col.headerAttributes}
              attributes={col.attributes}
              visible={col.visible !== false}
            />
          ))}

          {!isInactive && (
            <ColumnDirective
              headerText="Actions"
              template={actionTemplate}
            />
          )}
        </ColumnsDirective>
        <Inject services={[Page, Sort, Filter, DetailRow, ExcelExport, Toolbar, ColumnChooser]} />
      </GridComponent>







      {/* {workTypes.length > 0 && (
        <TablePagination
          component="div"
          count={workTypes.length}
          page={page}
          onPageChange={(_, e) => {
            updateParams({
              page: e,
              pageIncreasing: `${e > Number(params.get("page"))}`,
            });
          }}
          rowsPerPageOptions={[10, 25, 50, 100]}
          rowsPerPage={pageSize}
          onRowsPerPageChange={(e) => {
            updateParams({ pageSize: `${e.target.value}`, page: false });
          }}
        />
      )} */}

      <Box
        sx={{
          position: "fixed",
          bottom: "1rem",
          left: "4rem",
          "& > :not(style)": { m: 1 },
        }}
      >
        {!isInactive && (
          <Fab
            color="primary"
            aria-label="add"
            variant="extended"
            onClick={handleOpenModal}
          >
            <AddIcon sx={{ mr: 1 }} />
            New
          </Fab>
        )}
      </Box>
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",      // white by default
            boxShadow: 24,
            p: 4,
            borderRadius: 1,
            maxHeight: "80vh",                 // restrict height to 80% of viewport
            overflowY: "auto",                 // enable vertical scrolling
          }}
        >
          <h2>Add New Work Type</h2>

          {/* <FormControl fullWidth>
            <InputLabel>Work Type</InputLabel>
            <Select
              value={newWorkType}
              required
              onChange={(e) => setNewWorkType(e.target.value)}
              sx={{ marginBottom: "1rem" }}
            >
              <MenuItem value="PL">PL (Plumbing)</MenuItem>
              <MenuItem value="AT">AT (Architectural)</MenuItem>
              <MenuItem value="EL">EL (Electrical)</MenuItem>
              <MenuItem value="OT">OT (Other)</MenuItem>
              <MenuItem value="MH">MH (Mechanical)</MenuItem>
              <MenuItem value="SP">SP (Sprinkler)</MenuItem>
              <MenuItem value="FA">FA (Fire Alarm)</MenuItem>
            </Select>
          </FormControl> */}

          <FormControl fullWidth>
            <TextField
              label="Work Type"
              name="workType"
              variant="outlined"
              select
              value={newWorkType || ""}
              onChange={(e) => setNewWorkType(e.target.value)}
              sx={{ marginBottom: "1rem" }}
              InputProps={{
                endAdornment: newWorkType ? (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setNewWorkType("")}
                      style={{ marginRight: '10px' }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ) : null
              }}
            >
              <MenuItem value="AN">AN (Antenna)</MenuItem>
              <MenuItem value="AT">AT (Architectural)</MenuItem>
              <MenuItem value="BE">BE (Boiler Equipment)</MenuItem>
              <MenuItem value="FN">FN (Construction Fence)</MenuItem>
              <MenuItem value="CC">CC (Curb Cut)</MenuItem>
              <MenuItem value="EA">EA (Earthwork)</MenuItem>

              <MenuItem value="EL">EL (Electrical)</MenuItem>
              <MenuItem value="FA">FA (Fire Alarm)</MenuItem>
              <MenuItem value="FO">FO (Foundation)</MenuItem>
              <MenuItem value="GC">GC (General Construction)</MenuItem>
              <MenuItem value="GC-CX">GC-CX (Combined (GC  others))</MenuItem>
              <MenuItem value="LA">LA (Limited Alteration Applications (LAA))</MenuItem>

              <MenuItem value="MS">MS (Mechanical Systems)</MenuItem>
              <MenuItem value="MH">MH (Mechanical/HVAC)</MenuItem>
              <MenuItem value="OT">OT (Other)</MenuItem>
              <MenuItem value="PA">PA (Place of Assembly)</MenuItem>
              <MenuItem value="PL">PL (Plumbing)</MenuItem>
              <MenuItem value="PM">PM (Protection and Mechanical Methods)</MenuItem>

              <MenuItem value="SP">SP (Sprinkler)</MenuItem>
              <MenuItem value="SD">SD (Standpipe)</MenuItem>
              <MenuItem value="SE">SE (Support of Excavation)</MenuItem>
              <MenuItem value="SF">SF (Supported Scaffold)</MenuItem>
              <MenuItem value="SG">SG (Sign)</MenuItem>

              <MenuItem value="SH">SH (Sidewalk Shed)</MenuItem>
              <MenuItem value="ST">ST (Structural)</MenuItem>
              <MenuItem value="TA">TA (Temporary Place of Assembly)</MenuItem>
              <MenuItem value="VT">VT (Elevator)</MenuItem>

            </TextField>
          </FormControl>

          <TextField
            label="Estimated Cost"
            type="number"
            value={estimatedCost}
            onChange={(e) => setEstimatedCost(e.target.value)}
            fullWidth
            sx={{ marginBottom: "1rem" }}
          />



          {/* <TextField
            label="Applicant"
            value={applicant}
            onChange={(e) => setApplicant(e.target.value)}
            fullWidth
            select
            sx={{ marginBottom: "1rem" }}
          >
            {contacts.map((contact) => (
              <MenuItem key={contact.id} value={contact.id}>
                {contact.fullName}
              </MenuItem>
            ))}
          </TextField> */}

          <FormControl fullWidth sx={{ marginBottom: "1rem" }}>
            <InfiniteScrollSelect
              collectionName="contacts"
              label="fullName"
              onChange={(e, selected) => setApplicant(e.target.value)} // Store the entire selected object
              value={applicant}
              name="applicant"
              inputLabel="Applicant"
            />

          </FormControl>

          {/* <TextField
            label="Filing Representative"
            value={filingRepresentative}
            onChange={(e) => setFilingRepresentative(e.target.value)}
            fullWidth
            select
            sx={{ marginBottom: "1rem" }}
          >
            {contacts.map((contact) => (
              <MenuItem key={contact.id} value={contact.id}>
                {contact.fullName}
              </MenuItem>
            ))}
          </TextField> */}

          <FormControl fullWidth sx={{ marginBottom: "1rem" }}>
            <InfiniteScrollSelect
              collectionName="contacts"
              label="fullName"
              onChange={(e, selected) => setFilingRepresentative(e.target.value)} // Store the entire selected object
              value={filingRepresentative}
              // name="filingRepresentative"
              name="filingRep"
              inputLabel="Filing representative"
            />
          </FormControl>

          <TextField
            label="Date Filed"
            value={dateCreated}
            onChange={(e) => setDateCreated(e.target.value)}
            fullWidth
            type="date"
            defaultValue={new Date()}
            sx={{ marginBottom: "1rem" }}
          />

          <TextField
            label="Date Approved"
            type="date"
            value={dateApproved}
            onChange={(e) => setDateApproved(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: "1rem" }}
          />

          <TextField
            label="Permit Issued"
            type="date"
            value={permitIssued}
            onChange={(e) => setPermitIssued(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: "1rem" }}
          />

          <TextField
            label="Permit Expiration"
            type="date"
            value={permitExpiration}
            onChange={(e) => setPermitExpiration(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: "1rem" }}
          />

          <TextField
            label="Sign-off Requested"
            type="date"
            value={signOffRequested}
            onChange={(e) => setSignOffRequested(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: "1rem" }}
          />

          <TextField
            label="Signed Off On"
            type="date"
            value={signedOffOn}
            onChange={(e) => setSignedOffOn(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: "1rem" }}
          />

          <TextField
            label="Letter of Completion (LOC)"
            type="date"
            value={locDate}
            onChange={(e) => setLocDate(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: "1rem" }}
          />
          <TextField
            label="DOB Number"
            // required
            value={dobNumber}
            onChange={(e) => setDobNumber(e.target.value)}
            fullWidth
            sx={{ marginBottom: "1rem" }}
          />
          <TextField
            label="Comments"
            type="text"
            multiline
            rows={2}
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            fullWidth
            sx={{ marginBottom: "1rem" }}
          />
          {/* <Button
            variant="contained"
            color="primary"
            disabled={!newWorkType || !dateCreated || !dobNumber}
            onClick={handleAddWorkType}
            style={{ marginTop: 20 }}
          >
            Add
          </Button> */}
          <Button
            variant="contained"
            color="primary"
            disabled={!newWorkType || !dateCreated}
            onClick={handleAddWorkType}
            style={{ marginTop: 20 }}
          >
            Add
          </Button>

          <Button
            variant="contained"
            color="secondary"
            onClick={handleCloseModal}
            style={{ marginTop: 20 }}
            sx={{ marginLeft: "1rem" }}
          >
            Cancel
          </Button>
        </Box>
      </Modal>







      <Modal open={openUpdateModal} onClose={handleCloseUpdateModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 1,
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <h2>Update Work Type</h2>


          <FormControl fullWidth sx={{ marginBottom: "1rem" }}>
            <TextField
              label="Work Type"
              name="workType"
              variant="outlined"
              select
              value={currentWorkType?.workType || ""}
              onChange={(e) =>
                setCurrentWorkType((prev) => ({
                  ...prev,
                  workType: e.target.value,
                }))
              }
              InputProps={{
                endAdornment: currentWorkType?.workType ? (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() =>
                        setCurrentWorkType((prev) => ({ ...prev, workType: "" }))
                      }
                      style={{ marginRight: "10px" }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              }}
              sx={{ marginBottom: "1rem" }}
            >
              <MenuItem value="AN">AN (Antenna)</MenuItem>
              <MenuItem value="AT">AT (Architectural)</MenuItem>
              <MenuItem value="BE">BE (Boiler Equipment)</MenuItem>
              <MenuItem value="FN">FN (Construction Fence)</MenuItem>
              <MenuItem value="CC">CC (Curb Cut)</MenuItem>
              <MenuItem value="EA">EA (Earthwork)</MenuItem>
              <MenuItem value="EL">EL (Electrical)</MenuItem>
              <MenuItem value="FA">FA (Fire Alarm)</MenuItem>
              <MenuItem value="FO">FO (Foundation)</MenuItem>
              <MenuItem value="GC">GC (General Construction)</MenuItem>
              <MenuItem value="GC-CX">GC-CX (Combined (GC others))</MenuItem>
              <MenuItem value="LA">LA (Limited Alteration Applications (LAA))</MenuItem>
              <MenuItem value="MS">MS (Mechanical Systems)</MenuItem>
              <MenuItem value="MH">MH (Mechanical/HVAC)</MenuItem>
              <MenuItem value="OT">OT (Other)</MenuItem>
              <MenuItem value="PA">PA (Place of Assembly)</MenuItem>
              <MenuItem value="PL">PL (Plumbing)</MenuItem>
              <MenuItem value="PM">PM (Protection and Mechanical Methods)</MenuItem>
              <MenuItem value="SP">SP (Sprinkler)</MenuItem>
              <MenuItem value="SD">SD (Standpipe)</MenuItem>
              <MenuItem value="SE">SE (Support of Excavation)</MenuItem>
              <MenuItem value="SF">SF (Supported Scaffold)</MenuItem>
              <MenuItem value="SG">SG (Sign)</MenuItem>
              <MenuItem value="SH">SH (Sidewalk Shed)</MenuItem>
              <MenuItem value="ST">ST (Structural)</MenuItem>
              <MenuItem value="TA">TA (Temporary Place of Assembly)</MenuItem>
              <MenuItem value="VT">VT (Elevator)</MenuItem>
            </TextField>
          </FormControl>

          <TextField
            label="Estimated Cost"
            type="number"
            value={currentWorkType?.estimatedCost || ""}
            onChange={(e) =>
              setCurrentWorkType((prev) => ({
                ...prev,
                estimatedCost: e.target.value,
              }))
            }
            fullWidth
            sx={{ marginBottom: "1rem" }}
          />

          <FormControl fullWidth sx={{ marginBottom: "1rem" }}>
            <InfiniteScrollSelect
              collectionName="contacts"
              label="fullName"
              onChange={(e) =>
                setCurrentWorkType((prev) => ({
                  ...prev,
                  applicant: e.target.value,
                }))
              }
              value={currentWorkType?.applicant || ""}
              name="applicant"
              inputLabel="Applicant"
            />
          </FormControl>

          <FormControl fullWidth sx={{ marginBottom: "1rem" }}>
            <InfiniteScrollSelect
              collectionName="contacts"
              label="fullName"
              onChange={(e) =>
                setCurrentWorkType((prev) => ({
                  ...prev,
                  filingRepresentative: e.target.value,
                }))
              }
              value={currentWorkType?.filingRepresentative || ""}
              name="filingRep"
              inputLabel="Filing Representative"
            />
          </FormControl>

          <TextField
            label="Date Filed"
            type="date"
            value={currentWorkType?.dateFiled || ""}
            onChange={e => setCurrentWorkType(prev => ({ ...prev, dateFiled: e.target.value }))}
            fullWidth
            sx={{ marginBottom: "1rem" }}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            label="Date Approved"
            type="date"
            value={
              currentWorkType?.dateApproved
                ? new Date(currentWorkType.dateApproved)
                  .toISOString()
                  .split("T")[0]
                : ""
            }
            onChange={(e) =>
              setCurrentWorkType((prev) => ({
                ...prev,
                dateApproved: e.target.value,
              }))
            }
            fullWidth
            sx={{ marginBottom: "1rem" }}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            label="Permit Issued"
            type="date"
            value={
              currentWorkType?.permitIssued
                ? new Date(currentWorkType.permitIssued)
                  .toISOString()
                  .split("T")[0]
                : ""
            }
            onChange={(e) =>
              setCurrentWorkType((prev) => ({
                ...prev,
                permitIssued: e.target.value,
              }))
            }
            fullWidth
            sx={{ marginBottom: "1rem" }}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            label="Permit Expiration"
            type="date"
            value={
              currentWorkType?.permitExpiration
                ? new Date(currentWorkType.permitExpiration)
                  .toISOString()
                  .split("T")[0]
                : ""
            }
            onChange={(e) =>
              setCurrentWorkType((prev) => ({
                ...prev,
                permitExpiration: e.target.value,
              }))
            }
            fullWidth
            sx={{ marginBottom: "1rem" }}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            label="Sign-off Requested"
            type="date"
            value={
              currentWorkType?.signOffRequested
                ? new Date(currentWorkType.signOffRequested)
                  .toISOString()
                  .split("T")[0]
                : ""
            }
            onChange={(e) =>
              setCurrentWorkType((prev) => ({
                ...prev,
                signOffRequested: e.target.value,
              }))
            }
            fullWidth
            sx={{ marginBottom: "1rem" }}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            label="Signed Off On"
            type="date"
            value={
              currentWorkType?.signedOffOn
                ? new Date(currentWorkType.signedOffOn)
                  .toISOString()
                  .split("T")[0]
                : ""
            }
            onChange={(e) =>
              setCurrentWorkType((prev) => ({
                ...prev,
                signedOffOn: e.target.value,
              }))
            }
            fullWidth
            sx={{ marginBottom: "1rem" }}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            label="Letter of Completion (LOC)"
            type="date"
            value={
              currentWorkType?.locDate
                ? new Date(currentWorkType.locDate)
                  .toISOString()
                  .split("T")[0]
                : ""
            }
            onChange={(e) =>
              setCurrentWorkType((prev) => ({
                ...prev,
                locDate: e.target.value,
              }))
            }
            fullWidth
            sx={{ marginBottom: "1rem" }}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Comments"
            type="text"
            multiline
            rows={2}
            value={currentWorkType?.comments || ""}
            onChange={(e) =>
              setCurrentWorkType((prev) => ({
                ...prev,
                comments: e.target.value,
              }))
            }
            fullWidth
            sx={{ marginBottom: "1rem" }}
          />

          <TextField
            label="DOB Number"
            value={currentWorkType?.dobNumber || ""}
            onChange={(e) =>
              setCurrentWorkType((prev) => ({
                ...prev,
                dobNumber: e.target.value,
              }))
            }
            fullWidth
            sx={{ marginBottom: "1rem" }}
          />

          {!isInactive && (
            <Button
              variant="contained"
              color="primary"
              disabled={
                // must have required fields AND be dirty
                !currentWorkType?.workType ||
                !currentWorkType?.dateFiled ||
                !isDirty
              }
              onClick={handleUpdateWorkType}
              style={{ marginTop: 20 }}
            >
              Save
            </Button>
          )}
          <Button
            variant="contained"
            color="secondary"
            onClick={handleCloseUpdateModal}
            style={{ marginTop: 20, marginLeft: "1rem" }}
          >
            Close
          </Button>
        </Box>
      </Modal >




      <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
        <DialogTitle>Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this work type? This action cannot
            be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteWorkType} variant="contained" >
            Delete
          </Button>
          <Button onClick={handleCloseConfirmDialog} variant="contained" color="secondary" >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>


      <Snackbar
        open={feedbackMessage.open}
        autoHideDuration={2000}
        onClose={handleCloseFeedbackMessage}
      >
        <Alert
          onClose={handleCloseFeedbackMessage}
          severity={feedbackMessage.severity}
          sx={{ width: "100%" }}
        >
          {feedbackMessage.message}
        </Alert>
      </Snackbar>


    </div >
  );
};
